import { useTranslation } from 'react-i18next';
import { EMPTY_VIEW_ICONS, EmptyView } from '@shared/components/ui/EmptyView';

interface CategoriesEmptyStateProps {
  onCreateClick?: () => void;
  hasSearch?: boolean;
}

export function CategoriesEmptyState({ onCreateClick, hasSearch }: CategoriesEmptyStateProps) {
  const { t } = useTranslation('productCategoriesModule');

  if (hasSearch) {
    return (
      <EmptyView
        type="noResults"
        icon={EMPTY_VIEW_ICONS.DEFAULT}
        title={t('noResults.title')}
        description={t('noResults.description')}
      />
    );
  }

  return (
    <EmptyView
      type="emptyState"
      icon={EMPTY_VIEW_ICONS.DEFAULT}
      title={t('emptyState.title')}
      description={t('emptyState.description')}
      action={
        onCreateClick
          ? {
              label: t('emptyState.createButton'),
              onClick: onCreateClick,
              testId: 'create-first-category-button',
            }
          : undefined
      }
    />
  );
}
